import type { ReactNode } from "react";

type Props = {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
};

export default function SectionCard({ title, description, children, footer }: Props) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-xl overflow-hidden">
      <div className="px-5 md:px-6 pt-5 md:pt-6 pb-2">
        <h3 className="font-heading text-lg text-foreground-950">{title}</h3>
        {description && (
          <p className="text-xs text-foreground-600 mt-1">{description}</p>
        )}
      </div>
      <div className="px-5 md:px-6 py-4">{children}</div>
      {footer && (
        <div className="px-5 md:px-6 py-3 bg-background-100/60 border-t border-background-200 flex items-center justify-end gap-2">
          {footer}
        </div>
      )}
    </div>
  );
}